export default __webpack_public_path__ + "static/media/presale_decoration.c6761464.svg";